import { render, staticRenderFns } from "./AcceptedType.vue?vue&type=template&id=ab4ce81e&scoped=true&"
import script from "./AcceptedType.vue?vue&type=script&lang=js&"
export * from "./AcceptedType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4ce81e",
  null
  
)

export default component.exports